import React from 'react';

export const IsMobileContext = React.createContext(false);
